module.exports = __webpack_public_path__ + "img/index.cfcbd08f.png";